import { ReactElement } from "react";
import { UiLOneColumn } from "@rotorstudios/fe-ui";

import { UiDynamicRenderer } from "../../_common/modules/fe-ui/UiDynamicRenderer";
import useSpecifications from "./useSpecifications";

import "./_Specifications.scss";

const Specifications = (): ReactElement => {
  const { headerContent, mainContent, footerContent } = useSpecifications();

  const getHeaderContent = () => <UiDynamicRenderer data={headerContent} />;

  const getMainContent = () => <UiDynamicRenderer data={mainContent} />;

  const getFooterContent = () => <UiDynamicRenderer data={footerContent} />;

  return (
    <div className="Specifications">
      <UiLOneColumn
        headerContent={getHeaderContent()}
        mainContent={getMainContent()}
        footerContent={getFooterContent()}
      />
    </div>
  );
};

export default Specifications;
